import WixSDK from 'shared/utils/wix-sdk';
import { getCompId } from 'shared/utils/comp-id';
import { PAYMENT_TYPE } from 'shared/constants/payments';
import CLOSE_REASONS from 'full-screen-modals/constants/close-reasons';

const MOBILE_OVERLAY_ENTRY = 'mobile-overlay.html';
const FULL_SCREEN_OVERLAY_ENTRY = 'full-screen-modals.html';

const getRootCompId = () => `rootCompId=${getCompId()}`;

function getHostAndPath(withProtocol) {
  const protocol = withProtocol ? location.protocol : '';
  const host = location.host;
  const pathName = location.pathname.replace(/[^/]+$/, '');
  return `${protocol}//${host}${pathName}`;
}

function openPopup(path, width, height, theme, onClose) {
  const opener = restoreScroll => {
    WixSDK.openPopup(
      path,
      width,
      height,
      { origin: WixSDK.WindowOrigin.FIXED, placement: WixSDK.WindowPlacement.CENTER },
      function (response) {
        if (_.isFunction(onClose)) {
          onClose(response && response.message);
        }
        restoreScroll();
      }, theme);
  };

  openPopupOrModal(opener);
}

function openModal(path, width, height, theme, onClose) {
  const opener = restoreScroll => {
    WixSDK.openModal(path, width, height, function (response) {
      if (_.isFunction(onClose)) {
        onClose(response && response.message);
      }
      restoreScroll();
    }, theme);
  };

  openPopupOrModal(opener);
}

function openPopupOrModal(opener) {
  WixSDK.getBoundingRectAndOffsets()
    .then(rectAndOffsets => {
      const offsets = rectAndOffsets.offsets;
      const rect = rectAndOffsets.rect;

      function restoreScroll() {
        WixSDK.scrollTo(offsets.x, offsets.y - rect.top);
      }

      opener(restoreScroll);
    });
}

export function openMobileOverlay(subPath, onClose) {
  subPath = subPath ? `${subPath}` : '';
  const modalPath = `${getHostAndPath(true)}${MOBILE_OVERLAY_ENTRY}?${getRootCompId()}${subPath}`;
  openModal(modalPath, '100%', '100%', WixSDK.Theme.BARE, onClose);
}

export function openFullScreenOverlay(subPath, onClose = _.noop) {
  subPath = subPath ? `${subPath}` : '';
  const modalPath = `${getHostAndPath(true)}${FULL_SCREEN_OVERLAY_ENTRY}?${getRootCompId()}${subPath}`;
  openPopup(modalPath, '100%', '100%', WixSDK.Theme.BARE, ({ reason } = {}) => onClose(reason));
}

export function openFullScreenOverlayFromAppSettings(subPath) {
  subPath = subPath ? `${subPath}` : '';
  const modalPath = `${getHostAndPath(true)}${FULL_SCREEN_OVERLAY_ENTRY}?${getRootCompId()}${subPath}`;
  WixSDK.Settings.openModal(modalPath, '100%', '100%');
}

/**
 * Opens full-screen overlay with channel subscription info
 * @param channelId
 * @param onCloseByUser
 */
export function openFullScreenSubscribeOverlay(channelId, onCloseByUser = _.noop) {
  openFullScreenOverlay(
    `#/payment/${PAYMENT_TYPE.SUBSCRIPTION}/${channelId}`,
    reason => {
      if (reason === CLOSE_REASONS.CLOSED_BY_USER) {
        onCloseByUser();
      }
    });
}


/**
 * Opens full-screen overlay with video purchase info
 * @param channelId
 * @param videoId
 */
export function openFullScreenPurchaseOverlay(channelId, videoId) {
  openFullScreenOverlay(`#/payment/${PAYMENT_TYPE.PURCHASE}/${channelId}/${videoId}`);
}

/**
 * Opens full-screen overlay with member only video info
 * @param channelId
 * @param videoId
 * @param onClose
 */
export function openFullScreenMemberOnlyOverlay(channelId, videoId, onClose) {
  openFullScreenOverlay(`#/payment/${PAYMENT_TYPE.MEMBER_ONLY}/${channelId}/${videoId}`, onClose);
}

/**
 * Opens full-screen overlay with channel info
 * @param channelId
 */
export function openFullScreenChannelOverlay(channelId) {
  openFullScreenOverlay(`#/channel/${channelId}/info`);
}




// WEBPACK FOOTER //
// ./src/shared/utils/open-overlay.js